$(document).ready(function() {
   
    /* Every time the window is scrolled ... */
    $(window).scroll( function(){
    
        /* Check the location of each desired element */
        $('.fade-in-section, .sizeColumns, .newsletterBlock').each( function(i){
            
            var bottom_of_object = $(this).offset().top + $(this).outerHeight()/2;
            var bottom_of_window = $(window).scrollTop() + $(window).height();
            
            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window > bottom_of_object ){
                
                $(this).animate({'opacity':'1'},700);
                    
            }
            
        }); 
    
    });

    var d = new Date();
      var n = d.getDay();

      n = n > 0 ? n - 1 : 6; // zero is sunday, not monday in javascript

      $('.daily-Sched').eq(n).addClass('showItem');

      $('.shg-sld-dot').eq(n).addClass('showItem');

      $('.daily-Sched.showItem').parents('.shg-sld-fade, div').parent().addClass('showItem');
  
      //$('.desktopSlider .shg-sld-item:nth-child(8)').addClass('showItem');

      $('.desktopSlider .shg-sld-item:last').addClass('showItem');
  
	  //$('.desktopSlider .shg-sld-dots .shg-sld-dot:nth-child(8)').addClass('showItem');
  
      $('.desktopSlider .shg-sld-dots .shg-sld-dot:last').addClass('showItem');

      $('.desktopSlider .shg-sld-item').not('.showItem').remove();

      $('.desktopSlider .shg-sld-dot').not('.showItem').remove();

      $('.desktopSlider .shg-sld-item:first').addClass('shg-sld-active');

      $('.desktopSlider .shg-sld-dots .shg-sld-dot:first').addClass('shg-sld-active');
   

      //$('.daily-Sched2').eq(n).addClass('showItem');

      //$('.daily-Sched2.showItem').parents('.shg-sld-fade').parent().addClass('showItem');
  
      //$('.mobileSlider .shg-sld-item:last').addClass('showItem');
  
  	  //$('.mobileSlider .shg-sld-item').not('.showItem').remove();
  
      //$('.mobileSlider .shg-sld-item:first').addClass('shg-sld-active');
     
});


